export default async function CropAvatar(imageSrc, crop, shape = 'rect') {
  const image = new Image();
  image.src = imageSrc;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const diameter = Math.min(crop.width, crop.height);

  canvas.width = shape === 'circle' ? diameter : crop.width;
  canvas.height = shape === 'circle' ? diameter : crop.height;

  if (shape === 'circle') {
    ctx.beginPath();
    ctx.arc(diameter / 2, diameter / 2, diameter / 2, 0, 2 * Math.PI);
    ctx.clip();
  }

  ctx.drawImage(
    image,
    crop.x,
    crop.y,
    crop.width,
    crop.height,
    0,
    0,
    canvas.width,
    canvas.height
  );

  return canvas.toDataURL('image/jpeg');
}